import { Map, Container, Cpu, Flame } from "lucide-react";
import { EMBER, IMAGES } from "../mock";

const STEP_ICONS = [Map, Container, Cpu];
const STEP_IMAGES = [IMAGES.emberRefinery, IMAGES.emberPlant, IMAGES.emberServers];

export default function Ember() {
  return (
    <section id="ember" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0a1512]/60 to-transparent" />
      <div className="absolute -bottom-20 right-0 h-[420px] w-[420px] rounded-full bg-amber-500/6 blur-[140px]" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl reveal">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.22em] text-amber-300/90 uppercase">
            <Flame size={14} /> {EMBER.eyebrow}
          </span>
          <h2 className="font-display font-bold text-white text-3xl lg:text-5xl mt-4 leading-tight tracking-tight">
            {EMBER.title}
          </h2>
          <p className="mt-6 text-slate-300/85 leading-relaxed">{EMBER.intro}</p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {EMBER.steps.map((step, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <div
                key={i}
                className="reveal group relative overflow-hidden rounded-2xl border border-teal-500/12 bg-[#071815]/70 transition-all duration-300 hover:-translate-y-1.5 hover:border-teal-400/30"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={STEP_IMAGES[i]}
                    alt={step.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#071815] via-[#071815]/40 to-transparent" />
                  <span className="absolute top-4 left-4 font-display font-extrabold text-5xl text-white/15">
                    {step.num}
                  </span>
                  <span className="absolute bottom-4 left-4 flex h-11 w-11 items-center justify-center rounded-xl bg-teal-500/20 backdrop-blur text-teal-200 border border-teal-400/20">
                    <Icon size={20} />
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-semibold text-white text-lg leading-snug">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-slate-400 text-[15px] leading-relaxed">{step.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}